import { useLocation } from "react-router-dom";
import MikrobiWidget from "./MikrobiWidget";

/** Mikrobi ist derzeit offline (nicht öffentlich sichtbar). Auf true setzen, um ihn wieder zu aktivieren. */
const MIKROBI_ENABLED = false;

/** Blendet Mikrobi im Adminbereich aus und lädt ihn sonst nach. */
const MikrobiGate = () => {
  const { pathname } = useLocation();
  if (!MIKROBI_ENABLED) return null;
  if (pathname.startsWith("/admin")) return null;
  return <MikrobiWidget />;
};

export default MikrobiGate;
